import React, { memo } from 'react';

function HeaderContainer({ children, projectName }) {
  return (
    <header
      data-testid="headerContainer"
      className="headerContainer"
    >
      <div className="headerRow">
        <div className="brand-with-title">
          <div className="brand" />
          <span className="headerTitle">
            {projectName}
          </span>
        </div>
        <div className="headerSpacer">
          {children[0]}
        </div>
        {children[1]}
      </div>
    </header>
  );
}

export default memo(HeaderContainer);
